// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"587cec44","511":"34e01370","513":"ac4c936c"}[chunkId] + ".chunk.js";
};